import Axios from "axios";
import { baseURL } from "../../../api";
import {
    SET_EMPLOYEE_DETAILS,
    UNSET_EMPLOYEE_DETAILS,
    SET_EMPLOYEE_DETAILS_BY_USER,
    UNSET_EMPLOYEE_DETAILS_BY_USER,
} from "@/store/mutation-types";
import { getEmployeeDetails,getEmployeeDetailsByUser } from "@/store/api";

// Create axios instance with proper base URL
const apiClient = Axios.create({
  baseURL: baseURL + '/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// initial state
const state = {
  employeeDetails: null,
  getEmployeeDetailsByUser: null,
  loading: false,
};

const getters = {
  getEmployeeDetails(state) {
    return state.employeeDetails;
  },
  getEmployeeDetailsByUser(state){
    return state.getEmployeeDetailsByUser;
  },
  getEmployeeDetailsLoading(state) {
    return state.loading;
  },
};

const mutations = {
  [SET_EMPLOYEE_DETAILS](state, data) {
    state.employeeDetails = data;
  },
  [UNSET_EMPLOYEE_DETAILS](state) {
    state.employeeDetails = null;
  },
  [SET_EMPLOYEE_DETAILS_BY_USER](state, data) {
    state.getEmployeeDetailsByUser = data;
  },
  [UNSET_EMPLOYEE_DETAILS_BY_USER](state) {
    state.getEmployeeDetailsByUser = null;
  },
  SET_EMPLOYEE_DETAILS_LOADING(state, loading) {
    state.loading = loading;
  },
};

const actions = {
  getEmployeeDetailsByUser({ commit }, userId) {
    commit("SET_EMPLOYEE_DETAILS_LOADING", true);
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeDetailsByUser}/${userId}`)
        .then(function (response) {
          commit('SET_EMPLOYEE_DETAILS_BY_USER', response.data.data);
          commit("SET_EMPLOYEE_DETAILS_LOADING", false);
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_EMPLOYEE_DETAILS_BY_USER');
          commit("SET_EMPLOYEE_DETAILS_LOADING", false);
          reject(error);
        });
    });
  },
  getEmployeeDetails({ commit }, employeeId) {
    commit("SET_EMPLOYEE_DETAILS_LOADING", true);
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeDetails}/${employeeId}`)
        .then(function (response) {
          commit('SET_EMPLOYEE_DETAILS', response.data.data);
          commit("SET_EMPLOYEE_DETAILS_LOADING", false);
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_EMPLOYEE_DETAILS');
          commit("SET_EMPLOYEE_DETAILS_LOADING", false);
          reject(error);
        });
    });
  },

  getEmployeeGeneralInfo({ commit }, employeeId) {
    return new Promise((resolve, reject) => {
      apiClient.get(`/auth/hrm/get-employee-general-info/${employeeId}`)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  saveEmployeeGeneralInfo({ commit }, data) {
    return new Promise((resolve, reject) => {
      apiClient.post('/auth/hrm/save-update-employee-general-info', data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
